import React from 'react';
import classNames from 'classnames';

import { valueof } from '../../stores/types/types';
import Icon, { COLORS, ICONS } from './icon';

export interface SlidingButton {
	title: string;
	subtitle?: string;
	icon?: valueof<typeof ICONS>;
	onClick?: () => void;
	customIconSize?: number;
}

interface SlidingButtonGroupProps {
	activeButton: number;
	slidingButtons: SlidingButton[];
}

export default function SlidingButtonGroup({
	activeButton,
	slidingButtons,
}: SlidingButtonGroupProps) {
	return (
		<div className="sliding-button-group" data-testid="sliding-button-group">
			<div
				className={`sliding-button-background active-button-${activeButton}`}
				style={{
					width: `${100 / slidingButtons.length}%`,
					transform: `translateX(${activeButton * 100}%)`,
				}}
			/>
			{slidingButtons.map(({
				title,
				subtitle,
				icon,
				onClick,
				customIconSize = 24,
			}, index) => (
				<button
					key={index}
					onClick={onClick}
					className={classNames(
						'sliding-button',
						{ 'sliding-button--active': index === activeButton },
					)}
				>
					{icon && (
						<div className="sliding-button-icon">
							<Icon
								name={icon}
								size={customIconSize}
								color={
									index === activeButton
										? COLORS.TEXT_GRAY_1200
										: COLORS.DARK_GRAY_2
								}
							/>
						</div>
					)}
					<div className="sliding-button-text">
						<h5 className="bl-font-header">{title}</h5>
						{subtitle && <p className="bl-font-s2">{subtitle}</p>}
					</div>
				</button>
			))}
		</div>
	);
}
